import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { Section } from '../../../models';
import { InstallationTypeSectionIds, WeirInstallationFieldIds, WeirInstallationMp2FieldIds } from '../../common.models';
import { LocationDetails } from 'app/shared/models/location-details';
import { field } from '../../../core/field-schema';
import { required, maxLength, pattern } from '../../../core/validator-builders';
import { GenericLocationCardState } from '../models';

export const getValidators = function (isMetric: boolean) {
    const validators = [required(), maxLength({ value: 100 })];

    if (isMetric) {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationMetricValuePattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR_METRIC',
            }),
        ];
    } else {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationValuePattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR',
            }),
        ];
    }
};

export const getFlowValidators = function (isMetric: boolean) {
    const validators = [required(), maxLength({ value: 100 })];

    if (isMetric) {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationMetricValuePattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR_METRIC',
            }),
        ];
    } else {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationValue3DecimalPattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR_3_DECIMALS',
            }),
        ];
    }
};

// Weir installation type configuration (Series 300)
export const weirInstallationConfig = (state: GenericLocationCardState, isMp1: boolean): Section => {
    const settings = state.settings;
    let details: LocationDetails;

    if (state.locationDetails && state.locationDetails.length > 0) {
        details = isMp1 ? state.locationDetails[0] : state.locationDetails[1];
    }

    const FieldIds = isMp1 ? WeirInstallationFieldIds : WeirInstallationMp2FieldIds;

    return {
        info: {
            id: InstallationTypeSectionIds.Weir,
            title: '',
            displayTitle: false,
        },
        rows: [
            {
                info: {
                    id: 'weir-measurements-row',
                    panelClass: 'custom-33p',
                },
                items: [
                    field.number(FieldIds.Range, 'range', {
                        value: details ? details.range : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.RAIN_PLACEHOLDER',
                        placeholderSuffix: settings.depthUnit,
                        validators: getValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30 required',
                    }),
                    field.number(FieldIds.Capacity, 'capacity', {
                        value: details ? details.capacity : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.CAPACITY_PLACEHOLDER',
                        placeholderSuffix: settings.flowUnit,
                        validators: getFlowValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30 required',
                    }),
                    field.number(FieldIds.Height, 'height', {
                        value: details ? details.height : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.HEIGHT',
                        placeholderSuffix: settings.depthUnit,
                        validators: getValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30 required',
                    }),
                ],
            },
            {
                info: {
                    id: 'weir-dimensions-row',
                    panelClass: 'custom-33p',
                },
                items: [
                    field.number(FieldIds.Coefficient, 'coefficient', {
                        value: details ? details.coefficient : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.CONSTANT',
                        validators: getValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30 required',
                    }),
                    field.number(FieldIds.Length, 'length', {
                        value: details ? details.length : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.LENGTH',
                        placeholderSuffix: settings.depthUnit,
                        validators: getValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30 required',
                    }),
                    field.number(FieldIds.Breadth, 'breadth', {
                        value: details ? details.breadth : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.BREADTH',
                        validators: getValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30 required',
                    }),
                ],
            },
        ],
    };
};
